module.exports = __webpack_public_path__ + "static/media/background.8b306c54.png";